import {
  useTranslate as useTolgeeTranslate,
  useSetLanguage as useTolgeeSetLanguage,
  useCurrentLanguage as useTolgeeCurrentLanguage,
} from '@tolgee/react'

import type { LocationLanguage, TranslateFunction } from './types'

export const useTranslate = () => {
  const t = useTolgeeTranslate() as TranslateFunction
  return Object.assign(t, { t })
}

export const useSetLanguage = () => {
  const setLanguage = useTolgeeSetLanguage()
  return setLanguage
}

export const useCurrentLanguage = () => {
  const getCurrentLanguage = useTolgeeCurrentLanguage()
  const currentLanguage = getCurrentLanguage()

  return currentLanguage as LocationLanguage
}

export const useLanguage = () => {
  const language = useCurrentLanguage()
  const setLanguage = useTolgeeSetLanguage()

  return { language, setLanguage }
}
